export default "__VITE_ASSET__227d2a76__"